import { ChangePasswordForm } from "../components";

const ChangePasswordPage = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <ChangePasswordForm />
    </div>
  );
};

export default ChangePasswordPage;
